import React from "react";

type BadgeProps = {
  text: string;
  borderColor: string;
  textColor?: string;
};

const Badge = ({ borderColor, text, textColor }: BadgeProps) => {
  return (
    <div
      className="refund-btn"
      style={{
        borderRadius: "45px",
        border: `1px solid ${borderColor}`,
        padding: "0px 10px",
        display: "inline-block",
        textAlign: "center",
        width: "auto",
        fontSize: "12px",
      }}
    >
      <span style={{ color: textColor }}>{text}</span>
    </div>
  );
};

export default Badge;
